import styled from 'styled-components';
import { TableContainer } from '@material-ui/core';

const stickyStyle = {
  position: 'sticky',
  left: 0,
};

export const UiTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: 'unset',
  '& > table': {
    minWidth: '800px',
    tableLayout: 'fixed',
    '& > thead': {
      backgroundColor: '#F4F6F8',
      '& > tr > th': {
        borderBottom: 'unset',
        color: '#637381',
        fontSize: '16px',
        fontWeight: 500,
        '&:first-child': {
          borderRadius: '8px 0 0 8px',
          backgroundColor: '#F4F6F8',
          ...stickyStyle,
        },
        '&:last-child': {
          borderRadius: '0 8px 8px 0',
        },
      }
    },
    '& > tbody': {
      '& > tr > td': {
        borderBottom: 'unset',
        verticalAlign: 'top',
        '> p': {
          fontSize: '16px',
          color: '#212B36',
          fontWeight: 500,
        },
        '&:first-child': {
          backgroundColor: '#FFF',
          ...stickyStyle,
        },
        '&:not(:first-child)': {
          '.first-text': {
            fontSize: '18px',
            fontWeight: 700,
          },
          '.second-text': {
            fontWeight: 400,
          },
        },
      },
      // '& > tr:nth-of-type(even)': {
      //   backgroundColor: theme.palette.action.hover,
      // }
    },
  }
}));